/**
 * The Linktag service helps in setting link hreflang tags used for geotargeting
 */
var LinktagService = /** @class */ (function () {
    function LinktagService() {
        this.singleLanguage = false;
    }
    /**
     * Specifies the language configuration used to generate the HrefLang tags
     *
     * @param config the language configuration as defined in the config.json file
     */
    LinktagService.prototype.setLanguagesConfig = function (config) {
        this.languagesConfig = config;
        this.singleLanguage = config.available.length === 1;
    };
    /**
     * When invoked, it computes the canonical url and sets it to the html head
     * The url is computed based on:
     * - the relative path given (e.g. "/en/games/live-casino")
     * - the currently selected language
     *
     * @param urlPath the current url path
     * @param postProcess an optional post process function applied to the final canonical Url before injecting it in the html
     */
    LinktagService.prototype.setCanonicalTagFromPath = function (urlPath, postProcess) {
        if (!this.languagesConfig) {
            return;
        }
        var availableLangs = this.languagesConfig.available;
        var defaultLang = this.languagesConfig.default;
        var currentLang = this.getCurrentLang(urlPath, availableLangs, defaultLang);
        var canonicalUrl = this.createUrl(urlPath, currentLang);
        return this.setCanonicalTagFromUrl(postProcess ? postProcess(canonicalUrl) : canonicalUrl);
    };
    /**
     * When invoked, it sets/creates the needed HrefLang tag
     * setting the href attribute to the value specified
     *
     * @param canonicalUrl the url to set as canonical
     */
    LinktagService.prototype.setCanonicalTagFromUrl = function (canonicalUrl) {
        var tag = this.getCanonicalTag();
        if (!tag) {
            var createdTag = document.createElement('link');
            createdTag.setAttribute('rel', 'canonical');
            tag = document.head.appendChild(createdTag);
        }
        tag.setAttribute('href', canonicalUrl);
        return tag;
    };
    /**
     * Retrieves current language from the url if it is in the list of
     * supported langs, otherwise default language is returned
     * @param url the current url
     * @param langs list of supported languages
     * @param defaultLang default language
     * @returns the current language or default language
     */
    LinktagService.prototype.getCurrentLang = function (url, langs, defaultLang) {
        var currentLangRegexp = new RegExp("^/(" + langs.join('|') + ")");
        var matches = url.match(currentLangRegexp);
        return (matches && matches[1]) || defaultLang;
    };
    LinktagService.prototype.getCanonicalTag = function () {
        return document.querySelector("link[rel='canonical']");
    };
    LinktagService.prototype.createUrl = function (urlPath, lang) {
        var origin = window.location.origin;
        var slashIndex = urlPath.indexOf('/', 1);
        if (this.singleLanguage) {
            return "" + origin + urlPath;
        }
        else {
            var subIndex = slashIndex >= 0 ? slashIndex : 3; // handle missing trailing slash for home page
            return origin + "/" + lang + urlPath.substring(subIndex);
        }
    };
    return LinktagService;
}());
var linktag = new LinktagService();

export { LinktagService, linktag };
